module.exports = __webpack_public_path__ + "static/fonts/iconfont.181c1ca5.ttf";